import { Check, Handshake, ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Reveal";
import PartnerForm from "../components/PartnerForm";

const BENEFITS = [
  {
    icon: Handshake,
    title: "CLIENTI ACCOMPAGNATI",
    copy: "Arrivi dentro percorsi già coordinati dalla regia A.C. HUB: brief chiari, documenti ordinati, un referente che parla con il cliente.",
  },
  {
    icon: ShieldCheck,
    title: "ZERO COMMISSIONI DI SEGNALAZIONE",
    copy: "Non chiediamo né versiamo commissioni di segnalazione: entri nella rete per competenza, il rapporto è diretto con il cliente.",
  },
  {
    icon: Check,
    title: "PAGAMENTI DIRETTI",
    copy: "I pagamenti per il tuo lavoro li incassi direttamente dal cliente: niente passaggi interni, tutto trasparente.",
  },
];

export default function PartnerSection() {
  return (
    <section id="diventa-partner" className="section" data-testid="partner-section">
      <div className="container-hub">
        <SectionHeading
          eyebrow="La rete"
          title={<>SEI UN PROFESSIONISTA? <span className="gold-text">ENTRA NELLA RETE.</span></>}
          lead="Tecnici, architetti, imprese e consulenti: lavora con clienti accompagnati dalla regia A.C. HUB, dentro percorsi ordinati. La selezione è gratuita e avviene d'accordo con te."
          center
        />

        <div className="mt-14 grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="grid content-start gap-px border border-[#c9a45c]/22 bg-[#c9a45c]/22">
            {BENEFITS.map((b) => (
              <Reveal key={b.title} className="bg-[#0b0b0b]">
                <div className="flex min-h-[130px] items-start gap-4 p-6" data-testid={`partner-benefit-${b.icon.name}`}>
                  <b.icon size={18} strokeWidth={1.6} className="mt-0.5 shrink-0 text-gold" />
                  <div>
                    <h3 className="text-[11px] font-bold tracking-[0.14em] text-cream">{b.title}</h3>
                    <p className="mt-2 text-[13px] leading-relaxed text-[#929292]">{b.copy}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <div className="border border-[#c9a45c]/30 bg-[#0d0d0d] p-7 sm:p-9" data-testid="partner-form-card">
              <p className="eyebrow">Diventa partner</p>
              <h3 className="display mt-4 text-2xl sm:text-3xl">Presenta la tua realtà.</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#929292]">
                Due minuti per farci sapere chi sei: la direzione esamina ogni richiesta e risponde di persona.
              </p>
              <div className="mt-8">
                <PartnerForm />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
